var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_426_4943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16679 28.3335C10.5475 28.3335 11.6668 27.2142 11.6668 25.8335C11.6668 24.4528 10.5475 23.3335 9.16679 23.3335C7.78608 23.3335 6.66679 24.4528 6.66679 25.8335C6.66679 27.2142 7.78608 28.3335 9.16679 28.3335Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 5H8.33332C6.12399 5.00265 4.00591 5.88147 2.44368 7.4437C0.881455 9.00593 0.00263117 11.124 -1.52588e-05 13.3333L-1.52588e-05 26.6667C0.00263117 28.876 0.881455 30.9941 2.44368 32.5563C4.00591 34.1185 6.12399 34.9974 8.33332 35H31.6667C33.876 34.9974 35.9941 34.1185 37.5563 32.5563C39.1185 30.9941 39.9973 28.876 40 26.6667V13.3333C39.9973 11.124 39.1185 9.00593 37.5563 7.4437C35.9941 5.88147 33.876 5.00265 31.6667 5ZM8.33332 8.33333H31.6667C32.9927 8.33333 34.2645 8.86012 35.2022 9.7978C36.1399 10.7355 36.6666 12.0073 36.6666 13.3333H3.33332C3.33332 12.0073 3.8601 10.7355 4.79778 9.7978C5.73547 8.86012 7.00724 8.33333 8.33332 8.33333ZM31.6667 31.6667H8.33332C7.00724 31.6667 5.73547 31.1399 4.79778 30.2022C3.8601 29.2645 3.33332 27.9928 3.33332 26.6667V16.6667H36.6666V26.6667C36.6666 27.9928 36.1399 29.2645 35.2022 30.2022C34.2645 31.1399 32.9927 31.6667 31.6667 31.6667Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_426_4943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.0f305dd67b12ee2af645b65858ead045.svg";
export { ForwardRef as ReactComponent };